import { render, staticRenderFns } from "./YkText.vue?vue&type=template&id=510f97dc&scoped=true&"
import script from "./YkText.vue?vue&type=script&lang=js&"
export * from "./YkText.vue?vue&type=script&lang=js&"
import style0 from "./YkText.vue?vue&type=style&index=0&id=510f97dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510f97dc",
  null
  
)

export default component.exports